// extracted by mini-css-extract-plugin
module.exports = {"closedLeadsTable":"closedLeadsTable_closedLeadsTable__EhQqG"};